import React, { useCallback, useRef, useEffect, useState } from 'react';
import { FiLogIn, FiMail, FiLock, FiUser } from 'react-icons/fi';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { Link, useHistory, useLocation, useParams } from 'react-router-dom';
// import logo from '../../assets/logo-compressed.png';

import { supportNumber, authTitle, logo, urlWebsite, defaultProjectHash } from '../../config';
import { Container, Content, AnimatedDiv2, ErrorContainer } from './styles';
import Input from '../../components/Forms/Input';
import Button from '../../components/Button';
import getValidationErrors from '../../utils/getValidationErrors';

import { useAuth } from '../../hooks/Auth';
import { useToast } from '../../hooks/Toast';
import Whatsapp from '../../components/Whatsapp';
import { useLanguage } from '../../hooks/Language';
import Loader from '../../components/Loader';
import { FaLock, FaWhatsapp } from 'react-icons/fa';
import Logo from '../../components/Logo';
import { useConfiguration } from '../../hooks/Configuration';
import SignUp from '../SignUp';
import { Title } from '../Expositor/styles';
import { TitleUI } from '../../components/UIComponents/Title/styles';
import Paragraph from '../../components/UIComponents/Paragraph';
import Axios from 'axios';
import api from '../../services/api';
import { useLoading } from '../../hooks/LoadingHook';
import SouUmAssociado from '../SignInSouAssociado';
import SignInNaoAssociado from '../SignInNãoAssociado';



interface SignInData {
  email: string;
  password: string;
  name: string;
}

interface IParams {
  redirect?: string;
}

interface IParamsURL {
  projectHash?: string;
  eventHash?: string;
}

const SignIn: React.FC<IParams> = ({ redirect = '/' }) => {
  const history = useHistory();
  const [withPassword, setWithPassword] = useState(true);
  const { signIn } = useAuth();
  const { addToast } = useToast();
  const formRef = useRef<FormHandles>(null);
  const [loading, setLoading] = useState(false);
  const { translate } = useLanguage();
  const [errorMessage, setErrorMessage] = useState<Record<string, string>>({});
  const [manutencao, setManutencao] = useState(false);
  const [showSubscription, setShowSubscription] = useState(false);
  const { projectHash = defaultProjectHash, eventHash } = useParams<IParamsURL>();

  const [type, setType] = useState('none');
  const { configuration, setConfiguration } = useConfiguration();

  const { addLoading, removeLoading } = useLoading();

  const handleSubmit = useCallback(
    async (data: SignInData) => {


      addLoading({ title: 'Validando seu acesso', key: 'loading' })

      // Verificando se é associado
      const dataInfo = {
        login: data?.email,
        password: data?.password,
      };

      try {
        const checkAssociated = await api.post('signin-integration/sbcbm', dataInfo)
      }
      catch (err) { }

      try {
        formRef.current?.setErrors({});

        const shape = withPassword
          ? {
            email: Yup.string()
              .required(`${translate('Email')} ${translate('obrigatório')}`),
            password: Yup.string().required(`${translate('Senha')} ${translate('obrigatória')}`),
          }
          : {
            email: Yup.string()
              .required(`${translate('Email')} ${translate('obrigatório')}`)

          };

        const schema = Yup.object().shape(shape);
        const { email: email_trim } = data;
        data.email = email_trim.toLowerCase().trim();

        await schema.validate(data, { abortEarly: false });

        let { email, name, password } = data;

        email = email?.trim().toLowerCase();

        await signIn({ email, password, name, product_id: configuration?.current_event_id_response?.product_id, project_id: projectHash, event_id: eventHash ? eventHash : '' });
        removeLoading('loading');
        window?.location?.reload();

        return;
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          removeLoading('loading');
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);
          return;
        }
        removeLoading('loading');

        const { status } = err?.response;

        if (status >= 500) {

          setErrorMessage({ title: 'Um momento...', description: 'Estamos com alta demanda de pedidos de acesso. <br/><br/>Por favor refaça seu login em 1 minuto para acessar.' })
          setTimeout(() => {
            setErrorMessage({});
          }, 60000)

        }
        else {

          setErrorMessage({ title: '', description: 'Olá! Não localizamos o CPF informado em nossa base de dados. Por favor certifique-se de que está correto ou inscreva-se!' })
          setTimeout(() => {
            setErrorMessage({});
          }, 5000)

        }




      }
    },
    [signIn, addToast, history],
  );

  if (showSubscription) {
    return <SignUp />
  }


  return (<>
    {loading && <Loader message="Autenticando seu acesso ..." />}
    {type === 'none' ? <Container className='gap-sm pad row-to-column'>
      <Content>
        <AnimatedDiv2 className='shadowBox'>

          <TitleUI>Tenha um acesso completo</TitleUI><br />
          <Paragraph>Associe-se a SBCBM e tenha acesso ao conteúdo completo da plataforma, incluindo artigos exclusivos, videos, podcasts e muito mais!</Paragraph>
          <a href="https://www.sbcbm.org.br/iump-subscription-plan-3/" style={{ display: 'inline-block', color: '#555', fontWeight: 'bold', cursor: 'pointer', width: '100%', marginBottom: '20px' }}  >      <button className='greenButton2 ' style={{ width: '100%', maxWidth: '340px', minHeight: '50px', padding: '10px' }}


          >
            {translate('QUERO ME ASSOCIAR')}
          </button></a>


        </AnimatedDiv2>
      </Content>
      <Content>




        <AnimatedDiv2 className='shadowBox'>

          {manutencao ? <div className="onlineMessage ">

            <h2 className="defaultMarked"><div />{translate('Estamos em manutenção')}</h2>
            <p style={{ color: '#333', textAlign: 'center', marginTop: '20px' }}>
              {translate(
                'Voltamos em breve!',
              )}
            </p><br />
          </div> : <>
            <h2 style={{ margin: '20px auto' }} className="titleElement">{translate('SELECIONE A OPÇÃO')}</h2>



            <button type='button' onClick={() => setType('sou-associado')} className='greenButton2 buttonColored' style={{ width: '100%', maxWidth: '340px', minHeight: '50px', padding: '10px' }}


            >
              {translate('SOU UM ASSOCIADO')}
            </button>

            <button type='button' onClick={() => setType('não-associado')} className='greenButton2 buttonColored' style={{ width: '100%', maxWidth: '340px', minHeight: '50px', padding: '10px' }}


            >
              {translate('NÃO SOU ASSOCIADO')}
            </button>
          </>}

        </AnimatedDiv2>
      </Content>
    </Container> : <></>}

    {type === 'sou-associado' ? <SouUmAssociado setCallback={() => setType('none')} /> : <></>}
    {type === 'não-associado' ? <SignInNaoAssociado setCallback={() => setType('none')} /> : <></>}
  </>
  );
};
export default SignIn;
